import { render, staticRenderFns } from "./electiveImportDialog.vue?vue&type=template&id=780ca33f&"
import script from "./electiveImportDialog.vue?vue&type=script&lang=js&"
export * from "./electiveImportDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports